import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../CommonComponents/Footer';
import SideBar from '../SideBar';

const DashboardLayout: React.FC = () => {
  return (
    <div className="flex h-screen overflow-x-hidden">
      <SideBar />
      <main className="flex-1 dashboard overflow-y-auto bg-gradient-to-br from-[#EEE1E8] to-[#DCCFD7] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden pb-5">
        <Outlet />
        <Footer />
      </main>
    </div>
  );
};

export default DashboardLayout;
